import axios from 'axios'

const default_error_message = 'Error accesing the requested resource.'
const default_status_code = 400
const success_alert = {message: 'Success!', variant:'success', timer: 1000}
const error_alert = {message: default_error_message, variant:'danger'}

export const client = axios.create({
    json: true
})

const execute = async(method, {service, resource}, data) => { 
    const accessToken = localStorage.getItem('jwt')
    const request = {
        method,
        baseURL: service,
        url: resource,
        data,
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    }
    try{
        const { data } = await client(request)
        return data
    } catch(e){
        error_alert.message = e.response && e.response.data && e.response.data.message
        ?   e.response.data.message
        :   default_error_message

        let status_code = e.response && e.response.data && e.response.data.status_code
            ?   e.response.data.status_code
            :   default_status_code

        console.log("ex:" + status_code + ":" + error_alert.message)

        if (status_code == 403) {
            localStorage.clear()
            window.location.href = "./#/login";
        }
        
        throw e
    }
}

export const execute_generator = async function*(method, {service, resource}, payload) { 
    const { data } = await execute(method, {service, resource}, payload)
    yield data 
    ? {alert: success_alert, data: data}
    : {alert: error_alert}
}
